var React = require('react');

function IconCircledMinus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Page 1"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"fill":"#768D99"},React.createElement("path",{"d":"M3.546,7.4997 L9.454,7.4997 L9.454,5.4997 L3.546,5.4997 L3.546,7.4997 Z M6.411,-0.0003 C2.878,-0.0003 0,2.8707 0,6.4117 C0,9.9447 2.87,12.8227 6.411,12.8227 C9.945,12.8227 12.823,9.9527 12.823,6.4117 C12.823,2.8777 9.952,-0.0003 6.411,-0.0003 L6.411,-0.0003 Z"})))]);
}

IconCircledMinus.defaultProps = {"width":"13px","height":"13px","viewBox":"0 0 13 13","version":"1.1"};

module.exports = IconCircledMinus;

IconCircledMinus.default = IconCircledMinus;
